import { render, staticRenderFns } from "./AbsAvatar.vue?vue&type=template&id=34af29f8&scoped=true&"
import script from "./AbsAvatar.vue?vue&type=script&lang=js&"
export * from "./AbsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AbsAvatar.vue?vue&type=style&index=0&id=34af29f8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af29f8",
  null
  
)

export default component.exports